import { LineCurve3, SplineCurve, Vector2 } from "three";
import { MathX } from "../../../math/MathX";
import { Arrays } from "../../../tools/Arrays";

export class Curve
{
  #points:Vector2[] = [];
  #sorted = false;
  #cachedPointIndex = 0;

  get start(){ return this.#points[ 0 ]; }
  get end(){ return this.#points[ this.#points.length - 1 ]; }

  get xLength(){ return this.end.x - this.start.x; }

  
  set( points:Vector2[] )
  {
    this.#points = points;
    this.#sorted = false;
  }

  add( point:Vector2 )
  {
    this.#points.push( point );
    this.#sorted = false;
  }

  remove( index:number )
  {
    Arrays.removeAt( this.#points, index );
  }

  sort()
  {
    if ( this.#sorted )
    {
      return;
    }

    this.#points.sort( 
     ( a, b )=>
     {
       return a.x - b.x;
     } 
    );

    this.#sorted = true;
  }

  getY( x:number )
  {
    let p = this.#points[ this.#cachedPointIndex ];

    if ( x === p.x )
    {
      return p.y;
    }

    let biggerPoint:Vector2;
    let smallerPoint:Vector2;

    let biggerIndex:number;
    let smallerIndex:number;
    
    if ( x > p.x )
    {
      biggerIndex = this.#getIndexWithBiggerX( x );      
      biggerPoint = this.#points[ biggerIndex ];

      if ( biggerIndex == 0 || biggerPoint.x < p.x)
      {
        return biggerPoint.y; 
      }
      
      smallerIndex = biggerIndex - 1;
      smallerPoint = this.#points[ smallerIndex ];      
      
    }
    else 
    {
      smallerIndex = this.#getIndexWithSmallerX( x );
      smallerPoint = this.#points[ smallerIndex ];

      if ( smallerIndex == ( this.#points.length - 1 ) || smallerPoint.x > p.x )
      {
        return smallerPoint.y;
      }

      biggerIndex = smallerIndex + 1;
      biggerPoint = this.#points[ biggerIndex ];
    }    

    this.#setCachedPoint( smallerPoint, biggerPoint, x, smallerIndex, biggerIndex );
    return this.#lerpY( smallerPoint, biggerPoint, x );
  }

  #setCachedPoint( smaller:Vector2, bigger:Vector2, x:number, smallerIndex:number, biggerIndex:number )
  {
    let smallerDistance = Math.abs( smaller.x - x );
    let biggerDistance = Math.abs( bigger.x - x );

    return smallerDistance < biggerDistance ? smallerIndex : biggerIndex;
  }

  #lerpY( p0:Vector2, p1:Vector2, x:number )
  {
    let lerpAmount = ( x - p0.x ) / ( p1.x - p0.x );
    
    return MathX.lerp( p0.y, p1.y, lerpAmount );
  }

  #getIndexWithBiggerX( x:number )
  {
    let index = this.#cachedPointIndex;

    let p = this.#points[ index ];

    while ( index < this.#points.length && x > p.x )
    {      
      index++;
      p = this.#points[ index ];
    }

    return index;
  }

  #getIndexWithSmallerX( x:number )
  {
    let index = this.#cachedPointIndex;

    let p = this.#points[ index ];

    while ( index >= 0 && x < p.x )
    {      
      index--;
      p = this.#points[ index ];
    }

    return index;
  }


}